
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestReleaseSection from './components/LatestReleaseSection';
import NewsSection from './components/NewsSection';
import UpcomingLiveSection from './components/UpcomingLiveSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <LatestReleaseSection />
        <UpcomingLiveSection />
        <NewsSection />
      </main>
      <Footer />
    </div>
  );
}
